import { render } from "./AvatarBackground.vue?vue&type=template&id=067c63f6"
import script from "./AvatarBackground.vue?vue&type=script&lang=ts"
export * from "./AvatarBackground.vue?vue&type=script&lang=ts"
script.render = render

export default script